import { render, staticRenderFns } from "./AddDeviceByod.vue?vue&type=template&id=05afdf8d&"
import script from "./AddDeviceByod.vue?vue&type=script&lang=js&"
export * from "./AddDeviceByod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05afdf8d')) {
      api.createRecord('05afdf8d', component.options)
    } else {
      api.reload('05afdf8d', component.options)
    }
    module.hot.accept("./AddDeviceByod.vue?vue&type=template&id=05afdf8d&", function () {
      api.rerender('05afdf8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/adddevice/adddevicebyod/AddDeviceByod.vue"
export default component.exports